import React from 'react';
import PropTypes from 'prop-types';

import './style.scss';

const OptionSubtitle = ({ children }) => {
  return (
    <h6 className="uni-select__subtitle">
      {children}
    </h6>
  );
};

OptionSubtitle.propTypes = {
  children: PropTypes.node,
};

export default OptionSubtitle;



// WEBPACK FOOTER //
// ./src/selects/option-subtitle/index.jsx